module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9yr77"))).then(() => parcelRequire('2KbAe'));